import React, { FC } from 'react';
import s from './GalleryGrid.module.scss';
import GalleryHeaderContainer from '../GalleryHeader/GalleryHeaderContainer';

export type GalleryGridProps = {
  header?: React.ReactNode;
  content?: React.ReactNode;
  listClassName?: string;
  listGridClassOverride?: string;
};
const GalleryGrid: FC<GalleryGridProps> = ({
  content,
  header,
  listGridClassOverride,
  listClassName,
}) => {
  const listGridClass = listGridClassOverride
    ? listGridClassOverride
    : s.content;

  return (
    <div className={s.gridContainer}>
      <GalleryHeaderContainer className={s.header}>
        {header}
      </GalleryHeaderContainer>
      <ul className={`${listGridClass} ${listClassName}`}>{content}</ul>
    </div>
  );
};

export default GalleryGrid;
